<mat-form-field
  appearance="outline"
  floatLabel="always"
  class="moneyball-battle-datepicker tw-max-w-56">
  <mat-label> Date Range </mat-label>
  <mat-date-range-input
    [formGroup]="range"
    [rangePicker]="picker"
    [dateFilter]="endDateFilter"
    [min]="earliestDate"
    [max]="latestDate">
    <input matStartDate formControlName="start" (click)="picker.open()" placeholder="Start date" />
    <input matEndDate formControlName="end" (click)="picker.open()" placeholder="End date" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker
    #picker
    startView="multi-year"
    (monthSelected)="setMonthAndYear($event, picker)"
    [calendarHeaderComponent]="getHeaderComponent()"></mat-date-range-picker>
</mat-form-field>
